module.exports = __webpack_public_path__ + "img/bgc4.fc4df98f.png";